import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Typography, Dialog, DialogTitle, DialogContent, Stack, Card, CardContent, IconButton, Menu, MenuItem, Chip } from '@mui/material';

import '../homepage/Homepage.css';
import MainImage from '../homepage/images/mainImage.png';
import CtaImage from '../homepage/images/ctaImage.png';
import IntegrationImage from '../homepage/images/integration.jpg';
import FoodCourt from '../homepage/images/foodcourt.png';
import Finedine from '../homepage/images/finedine.png';
import Cafe from '../homepage/images/cafe.png';
import Bar from '../homepage/images/bar.png';
import Pizza from '../homepage/images/pizza.png';
import QRS from '../homepage/images/ORS.png';
import Desserts from '../homepage/images/desserts.png';
import Bakery from '../homepage/images/bakery.png';
import Cloudkitchen from '../homepage/images/cloudkitchen.png';
import Largechain from '../homepage/images/restaurant.png';

import Navbar from '../homepage/components/Navbar';
import Features from '../homepage/components/Features';
import ContactForm from '../homepage/components/ContactForm';
import Footer from '../homepage/components/Footer';
import ScrollReveal from '../homepage/components/ScrollReveal';

import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EngineeringIcon from '@mui/icons-material/Engineering';
import SecurityIcon from '@mui/icons-material/Security';
import SpeedIcon from '@mui/icons-material/Speed';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LanguageIcon from '@mui/icons-material/Language';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PrintIcon from '@mui/icons-material/Print';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CloudIcon from '@mui/icons-material/Cloud';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PublicIcon from '@mui/icons-material/Public';
import {
    Cancel, Window as WindowsIcon,
    Android as AndroidIcon,
    Apple as MacIcon,
    Terminal as LinuxIcon,
} from '@mui/icons-material';
import { API_BY_COUNTRY } from '../../hooks/commanFunc';
import { updateApiBaseUrl } from '../../hooks/apiHandler';

// Region configuration with pricing and currency
const REGION_CONFIG = {
    Canada: {
        currency: '$',
        price: '69',
        flag: '🇨🇦',
        label: 'Canada',
        phone: '1 (866) 992-0240'
    },
    India: {
        currency: '₹',
        price: '349',
        flag: '🇮🇳',
        label: 'India',
        phone: '+91 (951) 0649-106' // Update with actual Indian number
    }
};

export const HomePage = (props) => {
    const url = window.location.href;
    const [open, setOpen] = useState(false);
    const [region, setRegion] = useState("Canada");
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleLocationClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLocationClose = () => {
        setAnchorEl(null);
    };

    const handleRegionChange = (newRegion) => {
        setRegion(newRegion);
        window.localStorage.setItem("api_region", newRegion);
        const newUrl = API_BY_COUNTRY[newRegion] || API_BY_COUNTRY["Canada"];
        updateApiBaseUrl(newUrl, newRegion);
        handleLocationClose();
        // Reload page to apply changes
        window.location.reload();
    };

    const currentRegionConfig = REGION_CONFIG[region] || REGION_CONFIG.Canada;
    const PHONE_NUMBER = currentRegionConfig.phone;
    const SUPPORT_EMAIL = "support@miirapos.com";

    useEffect(() => {
        let detectedRegion = window.localStorage.getItem("api_region");
        if (detectedRegion) {
            setRegion(detectedRegion);
        } else {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // Detect region based on timezone
            if (timeZone.startsWith("Asia/Kolkata") || timeZone.startsWith("Asia/Calcutta")) {
                detectedRegion = "India";
            } else {
                detectedRegion = "Canada";
            }
            setRegion(detectedRegion);
            window.localStorage.setItem("api_region", detectedRegion);
        }
        const newUrl = API_BY_COUNTRY[detectedRegion] || API_BY_COUNTRY["Canada"];
        updateApiBaseUrl(newUrl, detectedRegion);
    }, []);

    const handlePlatformClick = (platformLabel) => {
        if (platformLabel === 'Windows') {
            const downloadUrl = url + "/downloads/MiiRAPOS_setup_v1.2.2.exe";
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.setAttribute('download', 'MiiRAPOS_setup_v1.2.2.exe');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else if (platformLabel === 'Android') {
            window.open("https://play.google.com/store/apps/details?id=com.miirapos.miira_pos", "_blank");
        } else if (platformLabel === 'IOS') {
            window.open("https://apps.apple.com/ca/app/miira-pos/id6747954842", "_blank");
        } else {
            alert(`The ${platformLabel} version is coming soon! Please contact us for early access.`);
            handleOpen();
        }
    };

    return (
        <Box sx={{ m: 0, p: 0 }} className="landingPage">
            <Navbar onOpenContact={handleOpen} region={region} />

            {/* Location Selector - Top Right Corner */}
            <Box sx={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999 }}>
                <Chip
                    icon={<PublicIcon />}
                    label={`${currentRegionConfig.flag} ${currentRegionConfig.label}`}
                    onClick={handleLocationClick}
                    sx={{
                        background: 'white',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        py: 2.5,
                        px: 1,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        cursor: 'pointer',
                        '&:hover': {
                            background: '#f5f5f5',
                            boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                        }
                    }}
                />
                <Menu
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleLocationClose}
                    PaperProps={{
                        sx: {
                            mt: 1,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        }
                    }}
                >
                    <MenuItem 
                        onClick={() => handleRegionChange('Canada')}
                        selected={region === 'Canada'}
                        sx={{ fontWeight: region === 'Canada' ? 'bold' : 'normal' }}
                    >
                        🇨🇦 Canada
                    </MenuItem>
                    <MenuItem 
                        onClick={() => handleRegionChange('India')}
                        selected={region === 'India'}
                        sx={{ fontWeight: region === 'India' ? 'bold' : 'normal' }}
                    >
                        🇮🇳 India
                    </MenuItem>
                </Menu>
            </Box>

            {/* Shift contents down due to fixed navbar design */}
            <Box sx={{ mt: '110px' }} />

            {/* Hero Section (Immediate load entry animation) */}
            <Box sx={{ background: '#fff', minHeight: '85vh', display: 'flex', alignItems: 'center', color: '#222', textAlign: 'center', pt: '20px' }}>
                <Container id='home' maxWidth="md">
                    <ScrollReveal direction="up" delay={0.1}>
                        <Typography sx={{ fontSize: { xs: '32px', md: '52px' }, fontWeight: 800, color: '#1a3a5a', lineHeight: 1.2 }} variant="h2" gutterBottom>
                            Smarter Cloud POS Ecosystem for Hospitality & High-Compliance Retail
                        </Typography>
                    </ScrollReveal>
                    
                    <ScrollReveal direction="up" delay={0.25}>
                        <Typography variant="h6" sx={{ color: '#555', maxWidth: '750px', mx: 'auto', mt: 2 }} gutterBottom>
                            Break free from legacy systems. Plans start at <strong style={{ color: 'tomato' }}>{currentRegionConfig.currency}{currentRegionConfig.price}/mo</strong> with <strong>Zero Upfront Setup Fees</strong>. Run MiiRA on devices you already own!
                        </Typography>
                    </ScrollReveal>

                    <ScrollReveal direction="up" delay={0.4}>
                        <Grid container spacing={2} sx={{ mb: 6, maxWidth: '800px', mx: 'auto', mt: 3 }}>
                            {[
                                { label: 'Windows', icon: <WindowsIcon /> },
                                { label: 'Android', icon: <AndroidIcon /> },
                                { label: 'IOS', icon: <MacIcon /> },
                                { label: 'Linux', icon: <LinuxIcon /> }
                            ].map((platform) => (
                                <Grid item xs={6} sm={3} key={platform.label}>
                                    <Button
                                        fullWidth
                                        variant="contained"
                                        startIcon={platform.icon}
                                        size="large"
                                        sx={{ color: '#fff', background: 'tomato', fontWeight: 'bold', transition: 'all 0.2s', '&:hover': { background: '#d34828', transform: 'translateY(-2px)' } }}
                                        onClick={() => handlePlatformClick(platform.label)}
                                    >
                                        {platform.label}
                                    </Button>
                                </Grid>
                            ))}
                        </Grid>
                    </ScrollReveal>

                    <ScrollReveal direction="scale" delay={0.55} duration={0.8}>
                        <Box sx={{ mt: 4 }}>
                            <img alt="MiiRA POS Ecosystem Interface layout mockup" src={MainImage} className='main_image' style={{ width: '100%', boxShadow: '0 25px 50px rgba(0,0,0,0.12)', borderRadius: '12px' }} />
                        </Box>
                    </ScrollReveal>
                </Container>
            </Box>

            {/* Ecosystem Comparison Matrix Section */}
            <Box sx={{ background: '#f8f9fa', py: '70px', borderTop: '1px solid #eaeaea', borderBottom: '1px solid #eaeaea' }}>
                <Container maxWidth="md">
                    <ScrollReveal direction="up">
                        <Typography variant="h4" textAlign="center" sx={{ fontWeight: 700, color: '#1a3a5a', mb: 5 }}>
                            How MiiRA Destroys Legacy Competitors
                        </Typography>
                    </ScrollReveal>
                    
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={6}>
                            <ScrollReveal direction="right" delay={0.15}>
                                <Card sx={{ height: '100%', borderTop: '4px solid #d32f2f' }}>
                                    <CardContent>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#d32f2f', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <HighlightOffIcon /> Old-School Legacy Systems
                                        </Typography>
                                        <Stack spacing={1.5}>
                                            <Typography variant="body2">• Proprietary hardware locks ($1,500+ per screen)</Typography>
                                            <Typography variant="body2">• Predatory 3-to-5 year mandatory contracts</Typography>
                                            <Typography variant="body2">• Hidden processing gateway markups and strict rules</Typography>
                                            <Typography variant="body2">• Slow, outsourced overseas customer call support lines</Typography>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </ScrollReveal>
                        </Grid>
                        
                        <Grid item xs={12} sm={6}>
                            <ScrollReveal direction="left" delay={0.3}>
                                <Card sx={{ height: '100%', borderTop: '4px solid #2e7d32', boxShadow: '0 8px 24px rgba(0,0,0,0.05)' }}>
                                    <CardContent>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#2e7d32', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <CheckCircleIcon /> The MiiRA POS Freedom Advantage
                                        </Typography>
                                        <Stack spacing={1.5}>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>• Bring Your Own Device (BYOD) — Use your iPads, Tablets, or PCs</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>• Zero Long-Term Contracts — True Month-to-Month flexibility</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>• Processor Agnostic — Keep your current low merchant rates</Typography>
                                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>• On-Site Field Support — Dedicated local engineering response</Typography>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </ScrollReveal>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Features Section */}
            <Box id='features' sx={{ display: 'flex', alignItems: 'center', color: '#222', textAlign: 'center', px: { xs: '15px', md: '50px' }, py: '60px' }}>
                <Container maxWidth="lg">
                    <ScrollReveal direction="up">
                        <Typography variant="h3" sx={{ fontWeight: 700, color: '#1a3a5a' }} gutterBottom>
                            One Smart POS. Absolute Operational Freedom.
                        </Typography>
                        <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                            Built-in features designed to streamline high-volume menus, staff operations, and multi-location infrastructure.
                        </Typography>
                    </ScrollReveal>

                    <ScrollReveal direction="scale" delay={0.2}>
                        <Features />
                    </ScrollReveal>
                    
                    <ScrollReveal direction="up" delay={0.3}>
                        <Button variant="contained" size="large" sx={{ mt: 5, px: 6, py: 1.5, color: '#fff', background: 'tomato', fontWeight: 'bold', fontSize: '16px' }} onClick={handleOpen}>
                            Claim Your 30-Day Free Trial
                        </Button>
                    </ScrollReveal>
                </Container>
            </Box>

            {/* Comprehensive Services Section */}
            <Box id='services' sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', px: { xs: '15px', md: '50px' }, py: '80px', color: '#fff' }}>
                <Container maxWidth="lg">
                    <ScrollReveal direction="up">
                        <Typography variant="h3" textAlign="center" sx={{ fontWeight: 700, mb: 2 }}>
                            Complete Cloud POS Ecosystem
                        </Typography>
                        <Typography variant="body1" textAlign="center" sx={{ color: 'rgba(255,255,255,0.9)', maxWidth: '850px', mx: 'auto', mb: 6 }}>
                            From order management to franchise operations, every tool you need to run your business efficiently is built into MiiRA POS. One unified platform that scales with your business.
                        </Typography>
                    </ScrollReveal>

                    <Grid container spacing={3}>
                        {[
                            { 
                                icon: <RestaurantMenuIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Advanced Menu Management', 
                                body: 'Build complex menus with modifiers, variants, side-car options, and advanced split configurations. Support for in-store, online, and partner-exclusive items. Perfect for pizzerias, customizable bowls, and build-your-own concepts.',
                                color: '#FF6B6B'
                            },
                            { 
                                icon: <InventoryIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Real-Time Inventory Control', 
                                body: 'Track stock levels across locations, set intelligent low-stock alerts, generate detailed inventory reports, manage suppliers, and automate reordering workflows. Complete inventory log history with transaction tracking.',
                                color: '#4ECDC4'
                            },
                            { 
                                icon: <DashboardIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Live Order Dashboard & KDS', 
                                body: 'Monitor all orders in real-time with Kitchen Display System (KDS), manage order flow between stations, track preparation times, and optimize kitchen efficiency. Unified view of in-store, online, and delivery orders.',
                                color: '#45B7D1'
                            },
                            { 
                                icon: <AssessmentIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Powerful Analytics & Reports', 
                                body: 'Access 9+ comprehensive report types: sales reports, employee performance metrics, tip tracking, shift reports, inventory logs, item-wise profitability, payment reports, custom reports, and cross-location analytics. All optimized for mobile and desktop.',
                                color: '#96CEB4'
                            },
                            { 
                                icon: <PeopleIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Advanced Staff & User Management', 
                                body: 'Create employee accounts with 6-tier role-based permissions (Global Admin, Franchise Owner, Store Admin, Manager, Supervisor, Cashier). Track time punches, manage shifts, monitor performance. Users can update their own details while security controls remain locked.',
                                color: '#FFEAA7'
                            },
                            { 
                                icon: <LanguageIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Custom Branded Online Ordering Website', 
                                body: 'Get your own fully branded online ordering website with customizable themes, color schemes, logo, menu display, customer accounts, FAQ pages, about pages, contact forms, and direct commission-free ordering. Complete website builder included.',
                                color: '#DFE6E9'
                            },
                            { 
                                icon: <LocalShippingIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Third-Party Delivery Integration', 
                                body: 'Seamlessly integrate Uber Eats, DoorDash, and other delivery platforms. Manage all in-house and third-party orders from a single unified dashboard. Automatic order routing to kitchen printers.',
                                color: '#74B9FF'
                            },
                            { 
                                icon: <EventSeatIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Table Reservation & Floor Management', 
                                body: 'Manage restaurant reservations, table assignments, customer waitlists, and floor layouts. Visual table status tracking perfect for fine dining and casual dining operations. Real-time seating availability.',
                                color: '#A29BFE'
                            },
                            { 
                                icon: <PrintIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Custom Print Layout Builder', 
                                body: 'Design your own receipt and kitchen ticket layouts with drag-and-drop builder. Configure multiple printers for different stations, order types, and ticket routing. Advanced device management for all terminals.',
                                color: '#FD79A8'
                            },
                            { 
                                icon: <AccessTimeIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Employee Time Punch & Labor Management', 
                                body: 'Built-in employee clock-in/out system with shift tracking, break management, overtime calculation, labor cost reporting, and payroll export functionality. Generate detailed employee performance and shift reports.',
                                color: '#FDCB6E'
                            },
                            { 
                                icon: <CreditCardIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Multi-Payment Gateway Support', 
                                body: 'Accept all payment methods — credit/debit cards, digital wallets, cash, gift cards, and split payments. Processor-agnostic flexibility with your preferred payment provider. Detailed payment tracking and reporting.',
                                color: '#6C5CE7'
                            },
                            { 
                                icon: <CloudIcon sx={{ fontSize: '40px' }} />, 
                                title: 'Franchise & Multi-Store Management', 
                                body: 'Oversee unlimited locations from one centralized dashboard. Track cross-location loyalty programs, consolidated reports, unified menu management, brand-wide analytics, and franchise-level oversight with hierarchical permissions.',
                                color: '#00B894'
                            }
                        ].map((service, index) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <ScrollReveal direction="up" delay={(index % 3) * 0.1}>
                                    <Card sx={{ 
                                        height: '100%', 
                                        background: 'rgba(255,255,255,0.95)', 
                                        borderRadius: '16px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': { 
                                            transform: 'translateY(-8px)', 
                                            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
                                            background: '#fff'
                                        }
                                    }}>
                                        <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ 
                                                background: service.color, 
                                                color: '#fff', 
                                                p: 2, 
                                                borderRadius: '12px', 
                                                display: 'inline-flex', 
                                                mb: 2,
                                                width: 'fit-content'
                                            }}>
                                                {service.icon}
                                            </Box>
                                            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1a3a5a', mb: 1.5 }}>
                                                {service.title}
                                            </Typography>
                                            <Typography variant="body2" sx={{ color: '#666', lineHeight: 1.6, flexGrow: 1 }}>
                                                {service.body}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </ScrollReveal>
                            </Grid>
                        ))}
                    </Grid>

                    <ScrollReveal direction="up" delay={0.3}>
                        <Box sx={{ textAlign: 'center', mt: 6 }}>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                                All Features. One Platform. Zero Extra Charges.
                            </Typography>
                            <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.95)', mb: 3, fontStyle: 'italic' }}>
                                And there's a lot more features coming soon — AI phone ordering, automated inventory predictions, advanced customer analytics, and more...
                            </Typography>
                            <Button 
                                variant="outlined" 
                                size="large" 
                                sx={{ 
                                    color: '#fff', 
                                    borderColor: 'rgba(255,255,255,0.5)', 
                                    fontWeight: 'bold',
                                    px: 4,
                                    py: 1.5,
                                    '&:hover': {
                                        borderColor: '#fff',
                                        background: 'rgba(255,255,255,0.1)'
                                    }
                                }} 
                                onClick={handleOpen}
                            >
                                Request Full Feature Demo
                            </Button>
                        </Box>
                    </ScrollReveal>
                </Container>
            </Box>

            {/* Maintenance & On-Site Engineering Support Section */}
            <Box sx={{ background: '#1a3a5a', px: { xs: '15px', md: '50px' }, py: '70px', color: '#fff' }}>
                <Container maxWidth="lg">
                    <ScrollReveal direction="up">
                        <Typography variant="h3" textAlign="center" sx={{ fontWeight: 700, mb: 2 }}>
                            Bulletproof Maintenance & Infrastructure Support
                        </Typography>
                        <Typography variant="body1" textAlign="center" sx={{ color: '#dfe6e9', maxWidth: '700px', mx: 'auto', mb: 6 }}>
                            Software is only as good as the network it runs on. We provide local field engineering expertise to ensure your infrastructure never fails you during a rush.
                        </Typography>
                    </ScrollReveal>

                    <Grid container spacing={4}>
                        {[
                            { icon: <EngineeringIcon sx={{ fontSize: '50px', color: 'tomato', mb: 2 }} />, title: 'On-Site Local Setup', body: 'We evaluate your building layout, mount terminal displays, run precision cabling, and completely eliminate hardware setup headaches.' },
                            { icon: <SecurityIcon sx={{ fontSize: '50px', color: 'tomato', mb: 2 }} />, title: 'Wi-Fi & Network Tune-Up', body: 'As network specialists, we isolate your POS terminals on secure, dedicated wireless channels to guarantee 100% cloud sync uptime.' },
                            { icon: <SpeedIcon sx={{ fontSize: '50px', color: 'tomato', mb: 2 }} />, title: '24/7 Redundancy Control', body: 'Local operational monitoring protects your store logs. If emergency problems rise on a Friday night, an on-site engineer responds immediately.' }
                        ].map((card, i) => (
                            <Grid item xs={12} sm={4} key={i}>
                                <ScrollReveal direction="up" delay={i * 0.15}>
                                    <Stack alignItems="center" sx={{ textAlign: 'center' }}>
                                        {card.icon}
                                        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>{card.title}</Typography>
                                        <Typography variant="body2" sx={{ color: '#dfe6e9' }}>{card.body}</Typography>
                                    </Stack>
                                </ScrollReveal>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* Integrations Section */}
            <Box sx={{ display: 'flex', alignItems: 'center', color: '#222', py: '60px', px: { xs: '15px', md: '50px' } }}>
                <Container maxWidth="lg">
                    <Grid container spacing={4} alignItems="center" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                        <Grid item xs={12} md={6}>
                            <ScrollReveal direction="right">
                                <Typography variant="h3" sx={{ fontWeight: 700, color: '#1a3a5a' }} gutterBottom>
                                    Multiple Integrations. Single Live Dashboard.
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#555', mb: 3 }}>
                                    Manage your complete business operations from one unified platform. All your sales channels, customer touchpoints, and business tools integrated seamlessly.
                                </Typography>
                                
                                <Grid container spacing={2} sx={{ mb: 4, justifyContent: { xs: 'center', md: 'left' } }}>
                                    {/* Available Features */}
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #27ae60', borderRadius: '8px', textAlign: 'center', background: '#e8f8f5' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#27ae60' }}>✓ Online Ordering Website</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #27ae60', borderRadius: '8px', textAlign: 'center', background: '#e8f8f5' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#27ae60' }}>✓ Gift Cards</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #27ae60', borderRadius: '8px', textAlign: 'center', background: '#e8f8f5' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#27ae60' }}>✓ Booking System</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #27ae60', borderRadius: '8px', textAlign: 'center', background: '#e8f8f5' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#27ae60' }}>✓ Offers & Promotions</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #27ae60', borderRadius: '8px', textAlign: 'center', background: '#e8f8f5' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#27ae60' }}>✓ Combo Deals</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #27ae60', borderRadius: '8px', textAlign: 'center', background: '#e8f8f5' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#27ae60' }}>✓ Weight Scale Integration</Typography>
                                        </Box>
                                    </Grid>
                                    
                                    {/* Coming Soon Features */}
                                    <Grid item xs={6}>
                                        <Box sx={{ p: 2, border: '2px solid #e67e22', borderRadius: '8px', textAlign: 'center', background: '#fef5e7' }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#e67e22' }}>🚀 Uber Eats (Coming Soon)</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Typography variant="body2" sx={{ color: '#777', fontStyle: 'italic', mb: 3 }}>
                                    *Plus: Loyalty programs, customer analytics, inventory management, staff scheduling, and multi-location franchise tools — all included!
                                </Typography>

                                <Button variant="outlined" size="large" sx={{ color: '#1a3a5a', borderColor: '#1a3a5a', fontWeight: 'bold' }} onClick={handleOpen}>
                                    Discover All Modules
                                </Button>
                            </ScrollReveal>
                        </Grid>
                        
                        <Grid item xs={12} md={6} sx={{ textAlign: 'center' }}>
                            <ScrollReveal direction="left" delay={0.2}>
                                <img alt="MiiRA Cloud POS Integration System layout design" src={IntegrationImage} style={{ width: '100%', maxWidth: '500px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }} />
                            </ScrollReveal>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            {/* Vertical Industry Blocks Section */}
            <Box sx={{ background: 'tomato', px: { xs: '15px', md: '50px' }, py: '80px', color: '#fff', textAlign: 'center' }}>
                <Container maxWidth="lg">
                    <ScrollReveal direction="up">
                        <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
                            Ecosystem Infrastructure Configured for Every Industry Block
                        </Typography>
                        <Typography variant="body1" sx={{ opacity: 0.9, maxWidth: '700px', mx: 'auto', mb: 6 }}>
                            No matter your business style, MiiRA POS scales effortlessly to match your inventory parameters and terminal targets.
                        </Typography>
                    </ScrollReveal>

                    <Grid container spacing={3} sx={{ justifyContent: 'center' }}>
                        {[
                            { name: 'Food Courts & Canteens', img: FoodCourt },
                            { name: 'Cafes & Bakeries', img: Cafe },
                            { name: 'Fine Dining Concepts', img: Finedine },
                            { name: 'Bars & Breweries', img: Bar },
                            { name: 'Pizzerias (Side-Car Modifiers)', img: Pizza },
                            { name: 'QSR & Fast Food outlets', img: QRS },
                            { name: 'Desserts & Juice Bars', img: Desserts },
                            { name: 'Cloud Kitchen Hubs', img: Cloudkitchen },
                            { name: 'Liquor Stores (Scale-Ready)', img: Largechain },
                            { name: 'Cannabis Retail', img: Bakery }
                        ].map((item, index) => (
                            <Grid item xs={6} sm={4} md={2.4} key={index}>
                                <ScrollReveal direction="scale" delay={(index % 5) * 0.1}>
                                    <Box sx={{ p: 2, background: 'rgba(255,255,255,0.1)', borderRadius: '12px', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-5px)' } }}>
                                        <img alt="" src={item.img} style={{ width: '60px', height: '60px', objectFit: 'contain', marginBottom: '10px' }} />
                                        <Typography variant='subtitle1' sx={{ fontWeight: 'bold', fontSize: '14px' }}>{item.name}</Typography>
                                    </Box>
                                </ScrollReveal>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>

            {/* High-Impact Action CTA Banner */}
            <Box sx={{ p: { xs: '30px 15px', md: '60px 50px' }, textAlign: 'center' }}>
                <Container maxWidth={'lg'}>
                    <ScrollReveal direction="scale">
                        <Box sx={{ background: '#1a3a5a', p: { xs: '40px 20px', md: '60px' }, borderRadius: '30px', color: '#fff' }}>
                            <Typography variant="h3" sx={{ fontWeight: 800, mb: 2 }}>
                                Get Started with $0 Setup Fee — Start Selling Smarter Today!
                            </Typography>
                            <Typography sx={{ color: '#dfe6e9', maxWidth: '650px', mx: 'auto', mb: 4 }} variant="body1">
                                Don't let expensive legacy vendors tie you down with contracts. Protect your margin rows with modern, fast local software deployment.
                            </Typography>
                            <Button variant="contained" size="large" sx={{ color: '#fff', background: 'tomato', fontWeight: 'bold', px: 6, py: 2, fontSize: '16px' }} onClick={handleOpen}>
                                Claim Your 30-Day Free Trial
                            </Button>
                            <Box sx={{ mt: 5 }}>
                                <img alt='MiiRA POS Terminal and KDS screen workflow array' style={{ maxWidth: '600px', width: '100%' }} src={CtaImage} />
                            </Box>
                        </Box>
                    </ScrollReveal>
                </Container>
            </Box>

            {/* Contact Us Section */}
            <Box id='contact' sx={{ py: '60px', px: { xs: '15px', md: '50px' }, color: '#222' }}>
                <Container maxWidth={'lg'}>
                    <ScrollReveal direction="up">
                        <Box sx={{ background: '#fff', p: { xs: '30px', md: '50px' }, borderRadius: '30px', boxShadow: '0 10px 40px rgba(0,0,0,0.06)' }}>
                            <Grid container spacing={4} alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h3" sx={{ fontWeight: 700, color: '#1a3a5a' }} gutterBottom>
                                        Connect Directly with Local Field Team
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                                        Need a customized layout or professional network evaluation for your restaurant or retail workspace? Contact us directly.
                                    </Typography>
                                    
                                    <Stack spacing={2}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{ background: '#f8f9fa', p: 1.5, borderRadius: '50%', display: 'flex' }}>
                                                <PhoneIcon sx={{ color: 'tomato' }} />
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ color: '#888', display: 'block' }}>Primary Support Line</Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#1a3a5a' }}>{PHONE_NUMBER}</Typography>
                                            </Box>
                                        </Box>
                                        
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{ background: '#f8f9fa', p: 1.5, borderRadius: '50%', display: 'flex' }}>
                                                <MailIcon sx={{ color: 'tomato' }} />
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ color: '#888', display: 'block' }}>Corporate Support Email</Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#1a3a5a' }}>{SUPPORT_EMAIL}</Typography>
                                            </Box>
                                        </Box>
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <ContactForm />
                                </Grid>
                            </Grid>
                        </Box>
                    </ScrollReveal>
                </Container>
            </Box>

            <Footer region={region} />

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant='h5' sx={{ fontWeight: 'bold', color: '#1a3a5a' }}>Book On-Site Evaluation</Typography>
                    <Cancel sx={{ cursor: 'pointer', color: '#999' }} onClick={handleClose} />
                </DialogTitle>
                <DialogContent>
                    <ContactForm onClose={handleClose} />
                </DialogContent>
            </Dialog>
        </Box>
    );
};